export const replaceURLDynamicFields = (url, toReplace) => {
  return Object.entries(toReplace).reduce((acc, [field, value]) => url.replace(`:${field}`, value), url);
};

export const getRequestDataFormat = (method, data) => {
  return method === 'get' ? { params: data } : { data };
};
